import type { Address, Team } from '@baseball-near-you/prisma';
import { type ButtonProps, DropdownMenuSelect } from '@baseball-near-you/ui';

export function AddressDropdownMenu({
  onSelect,
  selectedAddressId,
  team,
}: {
  selectedAddressId: string | null;
  onSelect: (address: Address) => void;
  filteredIds?: number[];
  triggerButtonProps?: ButtonProps;
  team?: Team & { address: Address[] };
}) {
  return team?.address && team.address.length > 0 ? (
    <DropdownMenuSelect
      onSelect={(addressId) => {
        const address = team?.address.find(
          (address) => address.id.toString() === addressId
        );
        if (address) {
          onSelect(address);
        }
      }}
      val={selectedAddressId}
      values={team?.address.map((address) => ({
        label: (
          <div className="flex flex-col gap-1">
            <p>
              {address.street} {address.street2 ?? ''}
            </p>
            <p className="font-medium">
              {address.city}, {address.state} {address.postalCode}
            </p>
          </div>
        ),
        value: address.id.toString(),
        displayLabel: `${address.street} ${address.street2 ?? ''} ${address.city}, ${address.state} ${address.postalCode}`,
      }))}
      defaultLabel="Choose one of your saved addresses"
      dropdownMenuClassName="min-w-64"
    />
  ) : null;
}
